import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RxIEDetectionComponent } from './rx-ie-detection.component';

const routes: Routes = [
  {
    path: '',
    component: RxIEDetectionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RxIEDetectionRoutingModule {}
